import React, { useEffect, useState } from "react";
import { Button, Row, Table } from "reactstrap";
import { useTranslation } from 'react-i18next';
import { english } from "flatpickr/dist/l10n/default.js";
import { MandarinTraditional } from "flatpickr/dist/l10n/zh-tw.js";
import { SummaryDate, SummaryFilter } from "../../Components/Common/SVG";
import DeviceFilter, { getAllEventHandlingOption, getAllFloorOption, getAllStatusOption, getAllTypeOption } from "../../Components/Common/DeviceFilter";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { REPORT_PAGE_SIZE } from "../../common/constants";
import ReportRow from "./ReportRow";
import EventEditModal from "../../Components/Common/EventEditModal";
import Select from "react-select";
import colors from "../../assets/scss/config/saas/_colors.scss";
import { setIsReportLoading, setReportEventDateRange, setReportEventSelectedCompanyID, setReportEventSelectedEventHandling, setReportEventSelectedMultiFloorPlan, setReportEventSelectedMultiMonitorStatus, setReportEventSelectedMultiMonitorType, setReportPage } from "../../slices/developer/reducer";
import { getAllCompanies, getEventReportByCompanyID, getFloorPlanByCompanyID } from "../../slices/developer/thunk";
import chroma from "chroma-js";

export const colourStylesDeviceFilter = (selectColor) => {
    return {
        menu: (styles) => ({
            ...styles,
            backgroundColor: colors.white
        }),
        menuList: (styles) => ({
            ...styles,
            backgroundColor: colors.white
        }),
        control: (styles) => ({
            ...styles,
            marginLeft: 6,
            marginRight: 6,
            backgroundColor: colors.white,
            border: '1px solid #e5e7eb',
            boxShadow: 'none',
            '&:hover': {
                border: '1px solid #e5e7eb',
            },
            minWidth: 200,
        }),

        option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            color: colors.textBlack,            // text always black
            backgroundColor: isSelected
                ? chroma(selectColor).alpha(0.15).css()
                : isFocused
                ? chroma(selectColor).alpha(0.10).css()
                : colors.white,
            ':active': {
                backgroundColor: chroma(selectColor).alpha(0.20).css(),
                color: colors.textBlack
            }
        }),

        singleValue: (styles) => ({
            ...styles,
            color: colors.textBlack,
            fontWeight: 500
        }),
    };
};


function ReportTable(props) {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    document.title = t('PageMain.DocumentTitle');
    const dateRange = useSelector(state => state.Developer.report.dateRange);
    const floorplan = useSelector((state => state.Developer.report.selectedCompanyFloorPlans));
    const monitorType = useSelector((state => state.StaticData.monitorType));    
    const monitorStatus = useSelector((state => state.StaticData.reportMonitorStatus));
    const eventReportReason = useSelector(state => state.StaticData.eventReportReason);
    const selectedMultiFloorPlan = useSelector(state => state.Developer.report.selectedMultiFloorPlan);
    const selectedMultiMonitorType = useSelector(state => state.Developer.report.selectedMultiMonitorType);
    const selectedMultiMonitorStatus = useSelector(state => state.Developer.report.selectedMultiMonitorStatus);
    const selectedMultiEventHandling = useSelector(state => state.Developer.report.selectedMultiEventHandling);
    const selectedCompanyID = useSelector(state => state.Developer.report.selectedCompanyID);
    const companyList = useSelector(state => state.Developer.company);
    const lastUpdated = useSelector(state => state.Developer.report.lastUpdated);
    const data = useSelector(state => state.Developer.report.eventIDs);
    const page = useSelector(state => state.Developer.report.pageNumber);
    const isLoading =  useSelector(state => state.Developer.report.isLoading);
    const totalEvents = useSelector(state => state.Developer.report.totalEvents);
    const [isOpenEditEventModal, setOpenEditEventModal] = useState(false);

    useEffect(() => {
        let defaultDate = new Date();
        defaultDate.setMonth(defaultDate.getMonth() - 1);
        if (dateRange === null) {
            setDateRange([new Date().getTime(), defaultDate.getTime()]);
        }
        setSelectedMultiFloorPlan([getAllFloorOption(t)]);
        setSelectedMultiMonitorType([getAllTypeOption(t)]);
        setSelectedMultiMonitorStatus([getAllStatusOption(t)]);
        setSelectedMultiEventHandling([getAllEventHandlingOption(t)]);
    }, [lastUpdated]);

    let calLang = english;
    if (i18n.language === "cn") {
        calLang = MandarinTraditional;
    }

    useEffect(() => {
       dispatch(getAllCompanies());
    }, []);

    useEffect(() => {
        if (!isLoading && selectedCompanyID !== null &&selectedMultiFloorPlan !== undefined && selectedMultiFloorPlan !== null && selectedMultiFloorPlan.length > 0 && dateRange !== null && dateRange.length === 2 && selectedMultiMonitorType !== undefined && selectedMultiMonitorType !== null && selectedMultiMonitorType.length > 0 && selectedMultiMonitorStatus !== undefined && selectedMultiMonitorStatus !== null && selectedMultiMonitorStatus.length > 0 && selectedMultiEventHandling !== undefined && selectedMultiEventHandling !== null && selectedMultiEventHandling.length > 0) {
            dispatch(setIsReportLoading(true));
            dispatch(getEventReportByCompanyID(selectedCompanyID.value, selectedMultiFloorPlan, selectedMultiMonitorType, selectedMultiMonitorStatus, selectedMultiEventHandling, dateRange, page, REPORT_PAGE_SIZE));
        }
    }, [page, dateRange, selectedMultiFloorPlan, selectedMultiMonitorType, selectedMultiMonitorStatus, selectedMultiEventHandling])

    useEffect(() => {
        if (!isLoading && selectedCompanyID !== null && selectedCompanyID !== undefined && selectedCompanyID !== "") {
            dispatch(getFloorPlanByCompanyID(selectedCompanyID.value));
            setSelectedMultiFloorPlan([getAllFloorOption(t)]);
            dispatch(setReportPage(1));
           }
    }, [selectedCompanyID])

    const setDateRange = (data) => {
        if (data !== undefined && data !== null && data.length === 2) {
            dispatch(setReportEventDateRange([new Date(data[0]).getTime(), new Date(data[1]).getTime()]));
        }
    }

    const setSelectedMultiFloorPlan = (data) => {
        if (data !== undefined && data !== null) {
            dispatch(setReportEventSelectedMultiFloorPlan(data));
        }
    }

    const setSelectedMultiMonitorType = (data) => {
        if (data !== undefined && data !== null) {
            dispatch(setReportEventSelectedMultiMonitorType(data));
        }
    }

    const setSelectedMultiMonitorStatus = (data) => {
        if (data !== undefined && data !== null) {
            dispatch(setReportEventSelectedMultiMonitorStatus(data));
        }
    }

    const setSelectedMultiEventHandling = (data) => {
        if (data !== undefined && data !== null) {
            dispatch(setReportEventSelectedEventHandling(data));
        }
    }

    const setSelectedCompanyID = (data) => {
        if (data !== undefined && data !== null) {
            dispatch(setReportEventSelectedCompanyID(data));
        }
    }


    return (
        <Row className="full-width">
            <div className="report-table-spin" style={{display: (isLoading?"inherit":"none")}}>
                <div className="spinner-border text-info" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
            <div style={{display: (isLoading?"none":"flex")}}>
            <div className="d-flex flex-row report-header">
                <div className="d-flex flex-row report-header-filter flex-wrap">
                    <div className="d-flex flex-row report-filter-item-container">
                        <div className="filter-icon-box d-flex align-items-center justify-content-center">
                            <SummaryFilter scale={1.2} />
                        </div>
                        <Select
                            value={selectedCompanyID}
                            isMulti={false}
                            isClearable={false}
                            placeholder={t('PageMain.Device.FilterCompanyPlaceholder')}
                            onChange={(value) => {
                                console.log("Selected company ID:", value);
                                setSelectedCompanyID(value);
                            }}
                            options={companyList.map((company) => ({ value: company.id, label: company.name_zh_t }))}
                            styles={colourStylesDeviceFilter(colors.blue)}
                        />
                        <div className="filter-floor-box">
                            <DeviceFilter 
                            floorplan={floorplan} monitorType={monitorType} monitorStatus={monitorStatus}
                            selectedMultiFloorPlan={selectedMultiFloorPlan} 
                            selectedMultiMonitorType={selectedMultiMonitorType} 
                            selectedMultiMonitorStatus={selectedMultiMonitorStatus} 
                            setSelectedMultiFloorPlan={setSelectedMultiFloorPlan}
                            setSelectedMultiMonitorType={setSelectedMultiMonitorType}
                            setSelectedMultiMonitorStatus={setSelectedMultiMonitorStatus} 
                            setSelectedMultiEventHandling={setSelectedMultiEventHandling}
                            eventHandling={eventReportReason}
                            selectedMultiEventHandling={selectedMultiEventHandling}/>
                        </div>
                    </div>
                    <div className="d-flex flex-row report-filter-item-container">
                        <div className="filter-icon-box d-flex align-items-center justify-content-center">
                            <SummaryDate scale={1.2} />
                        </div>
                        <div className="filter-date-box">
                            <Flatpickr
                                className="form-control"
                                onChange={(e) => { setDateRange(e) }
                                }
                                value={dateRange || ""}
                                options={{
                                    mode: "range",
                                    dateFormat: "Y-m-d",
                                    locale: {
                                        ...calLang
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div className="report-table-container" style={{display: (isLoading?"none":"block")}}>
                <div className="report-table">
                    <Table className="table-nowrap mb-0">
                        <thead className="table-light">
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">{t('PageReport.Table.ID')}</th>
                                <th scope="col">{t('PageReport.Table.StartDate')}</th>
                                <th scope="col">{t('PageReport.Table.StartTime')}</th>
                                <th scope="col">{t('PageReport.Table.Floor')}</th>
                                <th scope="col">{t('PageReport.Table.Room')}</th>
                                <th scope="col">{t('PageReport.Table.Location')}</th>
                                <th scope="col">{t('PageReport.Table.Event')}</th>
                                <th scope="col">{t('PageReport.Table.ReportReason')}</th>
                                <th scope="col">{t('PageReport.Table.Duration')}</th>
                                <th scope="col">{t('PageReport.Table.ArrivalTime')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((i) => {
                                return (
                                    <ReportRow key={i} eventID={i} setOpenEditEventModal={setOpenEditEventModal}/>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>
            <div className="report-pagination-container" style={{display: (isLoading?"none":"block")}}>
                <PaginationControl
                    page={parseInt(page)}
                    between={4}
                    total={parseInt(totalEvents)}
                    limit={REPORT_PAGE_SIZE}
                    changePage={(page) => {
                        dispatch(setReportPage(page));
                    }}
                    ellipsis={1}
                />
            </div>
            <EventEditModal
            show={isOpenEditEventModal}
            isEditable={false}
            onCloseClick={() => {
                setOpenEditEventModal(false);
            }} />
        </Row>
    );
}

export default ReportTable;